export default __webpack_public_path__ + "static/top-7dd1d3415ef56820ab5a00ea9a06374e.jpg";